import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Inject,
  Injector,
  Input,
} from '@angular/core';
import { Store } from '@sama/app-state';
import { DirectiveSuperclass } from '@sama/ng-core';
import { Observable } from 'rxjs';
import { FusionState } from '../../../../core/h3ml/state/fusion-state';
import { outputInfoStoreToken } from '../../../../core/h3ml/state/output-info';
import {
  fusionStoreToken,
  TaskWorkspaceStore,
} from '../../../../core/h3ml/state/task-workspace-store';
import { InteractionModeService } from '../../../../core/outputs/annotation/annotation-shared/utils/interaction-mode.service';
import { contentInjectorToken } from '../../annotation-shared/abstract-annotation-output-component';
import { AnnotationState2D } from '../../annotation-shared/state/root/annotation-state-2d';

@Component({
  selector: 'h3-vector-tagging-toolbars',
  templateUrl: './vector-tagging-toolbars.component.html',
  styleUrls: [
    '../../annotation-shared/toolbars/toolbar-grid.scss',
    './vector-tagging-toolbars.component.scss',
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class VectorTaggingToolbarsComponent extends DirectiveSuperclass {
  @Input({ required: true }) state!: AnnotationState2D;

  private readonly outputInfoStore = inject(outputInfoStoreToken);
  interactionModeIsCanvas$!: Observable<boolean>;
  readOnly$: Observable<boolean | undefined>;
  isRightPanelExpanded$ = this.fusionStore('isRightPanelExpanded').$;
  outputName = this.outputInfoStore.state().output.name;
  private taskWorkspaceStore = inject(TaskWorkspaceStore);

  constructor(
    @Inject(contentInjectorToken) public contentInjector: Injector,
    @Inject(fusionStoreToken) private fusionStore: Store<FusionState>,
    injector: Injector,
    interactionModeService: InteractionModeService,
  ) {
    super(injector);
    this.interactionModeIsCanvas$ = interactionModeService.isInMode$('canvas');
    this.readOnly$ = this.taskWorkspaceStore('readOnly').$;
  }
}
